import DOMPurify from 'isomorphic-dompurify'

/**
 * Secure DOMPurify configuration to prevent XSS attacks
 * Restricts allowed HTML tags and attributes to safe ones
 */
export const secureDOMPurifyConfig = {
  ALLOWED_TAGS: ['b', 'i', 'em', 'strong', 'span', 'br', 'p'],
  ALLOWED_ATTR: [],
  SANITIZE_DOM: true,
  FORBID_TAGS: [
    'script',
    'style',
    'iframe',
    'frame',
    'object',
    'embed',
    'form',
  ],
  USE_PROFILES: { html: true },
}

/**
 * Safely sanitizes content with secure configurations
 * Useful for preventing XSS attacks from URL-encoded payloads
 *
 * @param content - Content to sanitize
 * @param decode - Whether to decode the content before sanitizing (defaults to false)
 * @returns Sanitized content safe for rendering
 */
export const secureSanitize = (
  content: string | undefined | null,
  decode = false
): string => {
  if (!content) return ''

  const contentToProcess = decode ? decodeURIComponent(content) : content
  return DOMPurify.sanitize(contentToProcess, secureDOMPurifyConfig)
}

/**
 * Sanitizes and prepares content for use in dangerouslySetInnerHTML
 *
 * @param content - Content to sanitize
 * @returns Object with __html property containing sanitized content
 */
export const getSafeHtml = (
  content: string | undefined | null
): { __html: string } => {
  return { __html: secureSanitize(content) }
}
